import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, unref as _unref } from "vue"

import { PickAndPackCheckOutDeliverable, PickAndPackDeliveryType, PickAndPackParcelShopCheckOutDeliveryOption } from '@/storecontext/shared/api/server-apis';
import CheckoutDeliverableItems from '@/storecontext/checkout/ui/items/CheckoutDeliverableItems.vue';
import CheckoutDeliverableGoToNext from '@/storecontext/checkout/ui/CheckoutDeliverableGoToNext.vue';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import CheckoutPickAndPackParcelShopOption from '@/storecontext/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackParcelShopOption.vue';
import CheckoutPickAndPackHomeDeliveryOption from '@/storecontext/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackHomeDeliveryOption.vue';
import { useForm, useField } from 'vee-validate';
import { computed, watch } from 'vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackDeliverable',
  props: {
    deliverable: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: PickAndPackCheckOutDeliverable;
    index: number;
}



const { setPickAndPackToHomeDelivery, setPickAndPackToParcelShopDelivery, getNearestParcelShopsForDelivery } = useCheckout();
const { values: formValues } = useForm();
const { value: selectedDeliveryType } = useField('pickAndPack');

for (const option of props.deliverable.options) {
    if (option.isSelected) {
        formValues.pickAndPack = option.deliveryType;
    }
}

watch(() => selectedDeliveryType.value, async() => {
    if (selectedDeliveryType.value === PickAndPackDeliveryType.HomeDelivery) {
        setPickAndPackToHomeDelivery();
    } else if (selectedDeliveryType.value === PickAndPackDeliveryType.ParcelShop) {
        const basketParcelShop = props.deliverable.options.find(option => option.deliveryType === PickAndPackDeliveryType.ParcelShop) as PickAndPackParcelShopCheckOutDeliveryOption;
        if (basketParcelShop?.parcelShop) {
            setPickAndPackToParcelShopDelivery({ ...basketParcelShop.parcelShop });
        } else {
            const parcelShops = await getNearestParcelShopsForDelivery(props.deliverable.id, 1);
            const parcelShop = parcelShops[0];
            if (parcelShop) {
                setPickAndPackToParcelShopDelivery(parcelShop);
            }
        }
    }
});

const getDeliveryOption = (type: PickAndPackDeliveryType) => {
    switch (type) {
    case PickAndPackDeliveryType.HomeDelivery:
        return CheckoutPickAndPackHomeDeliveryOption;
    case PickAndPackDeliveryType.ParcelShop:
        return CheckoutPickAndPackParcelShopOption;
    default:
        return null;
    }
};

const isClientValid = computed<boolean>(() => {
    return props.deliverable.options.find(option => option.isSelected)?.deliveryType === selectedDeliveryType.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", null, [
    _createVNode(BlockLabelWithNamedArguments, {
      label: __props.deliverable.text,
      class: "text-center mb-x4"
    }, null, 8, ["label"]),
    (__props.deliverable.id)
      ? (_openBlock(), _createBlock(CheckoutDeliverableItems, {
          key: 0,
          deliverable: __props.deliverable
        }, null, 8, ["deliverable"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.deliverable.options, (option) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(getDeliveryOption(option.deliveryType)), {
        key: option.deliveryType,
        "deliverable-id": __props.deliverable.id,
        deliverable: __props.deliverable,
        "delivery-option": option
      }, null, 8, ["deliverable-id", "deliverable", "delivery-option"]))
    }), 128)),
    _createVNode(CheckoutDeliverableGoToNext, {
      index: __props.index,
      deliverable: __props.deliverable,
      "is-client-valid": _unref(isClientValid)
    }, null, 8, ["index", "deliverable", "is-client-valid"])
  ]))
}
}

})